import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { get as _get } from "lodash"
import { isUserLoggedIn, logout } from "../../../utils/session/logout";
import { addAlertWithTimeout } from "../../../store/calls/alertLoadingDispatch";
import { store } from "../../../store";
import * as actions from '../../../store/actions'
import { getSubdomain } from "../../../utils/general";
import Logo from "../logo/logo.js"
import { pullSubdomainStyleFromCookie } from '../../../utils/subdomains/configHandlers';

import subdomainStyles from "../../../subdomainStyles.json"
// assets

class PublicTopNav extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      menu_is_active: false,
    };
  }

  getOrgHomeLink = () => {
    const subdomain = getSubdomain();
    let org_home_link = pullSubdomainStyleFromCookie(subdomain)['org-home-link'] || null;
    console.log('org_home_link', org_home_link);
    return org_home_link;
  }

  render() {

    const is_light = this.props.isLight;

    return (
      <nav className={`navbar ${this.props.navbarClass ? this.props.navbarClass : ''}`} role="navigation" aria-label="main navigation">
        <div className="navbar-brand">
          <span className="ml-5">
            <Logo isHome mode={is_light ? "light" : "dark"} />
          </span>
          <a
            role="button"
            className={`navbar-burger  ${this.state.menu_is_active ? "is-active" : ""
              }`}
            onClick={() =>
              this.setState({ menu_is_active: !this.state.menu_is_active })
            }
            aria-label="menu"
            aria-expanded="false"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>

        <div
          className={`navbar-menu ${this.state.menu_is_active ? "is-active" : ""
            }`}
        >
          <div className="navbar-end">

            {!getSubdomain() ? (
              <>
                <Link to="/about" className="navbar-item">
                  About
                </Link>
                <a href="http://blog.cleanfi.com" className="navbar-item" target="_blank" rel="noreferrer">
                  Knowledge Base
                </a>
                <Link to="/create-account" className="navbar-item">
                  Create Account
                </Link>
              </>
            ) : (
                // {{!!getOrgHomeLink()} &&
                  <a href={`${this.getOrgHomeLink() || 'https://www.cleanfi.com'}`} className={`navbar-item ${is_light ? 'has-text-white' : 'is-primary'}`}>
                Organization home
              </a>
                
              
            )}
            {isUserLoggedIn() ? (
              <a className="navbar-item is-hoverable">
                {/* logged in */}
                <a className={`button  ${is_light ? 'is-white has-text-white' : 'is-primary has-text-white'}`}>
                  <span className="icon">
                    <i className="fas fa-user-circle" />
                  </span>
                  <span>Hi, {_get(this.props, 'tokenData.user_data.first_name', 'there')}.</span>
                </a>

                <div className="navbar-dropdown">
                  {!!(this.props.tokenData.admin ||
                    this.props.tokenData.funder_admins.length ||
                    this.props.tokenData.program_admins.length ||
                    (this.props.tokenData?.subdomain_admins || [])
                  ) &&
                    <Link to={
                      (this.props.tokenData?.subdomain_admins || []).length ? "/admin/site-dashboard" : "/admin"
                    } className="navbar-item">
                      Admin
                    </Link>
                  }
                  <Link to="/my-projects" className="navbar-item">
                    My Projects
                  </Link>
                  <hr className="navbar-divider" />
                  <a
                    className="navbar-item"
                    onClick={() => logout()}
                  >
                    Logout
                  </a>
                </div>
              </a>
            ) : (
              <>
                <div className="navbar-item">
                  <Link to="/create-account" className="navbar-item has-text-weight-semibold">
                    Create Account
                  </Link>

                </div>
                <div className="navbar-item has-dropdown is-hoverable">
                  <Link to="/login" className="navbar-item is-hoverable">
                    {/* not logged in */}
                    <button className={`button ${is_light ? 'is-white' : 'is-primary has-text-white'}`}>
                      <span className="icon">
                        <i className="fas fa-door-open" />
                      </span>
                      <span>Login</span>
                    </button>
                  </Link>

                </div>
              </>
            )}
          </div>
        </div>
      </nav>
    );
  }
}

const mapStateToProps = (state) => ({
  tokenData: state.user.decodedTokenData,
  subdomainInfo: state.session.subdomainInfo,
});

export default connect(mapStateToProps)(PublicTopNav);
